module.exports = __webpack_public_path__ + "static/media/customers1.dc8020b0.png";